import CorporateCourseMenuRedirectMiddleware from '@/middleware/CorporateCourseMenuRedirectMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'course-enrollments-view',
        path: '/courses/:courseId/enrollments',
        component: () => import('@/pages/courses/enrollments/Enrollments.vue'),
        props: true,
        beforeEnter: CorporateCourseMenuRedirectMiddleware,
        meta: {
            title: 'Enrollments',
            dataTablePage: true,
            singleLineBreadcrumb: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'course enrollment page' },
        },
    },
    {
        name: 'course-import',
        path: '/courses/:courseId/enrollments/import',
        component: () => import('@/pages/courses/enrollments/Import.vue'),
        props: true,
        meta: {
            title: 'Import Enrollment',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'course enrollment page' },
        },
    },
];
